import React from 'react'

import AIChatMessage from "../../../../../core/model2/ai/chat-message/chat-message"
import {AiChatMessageType} from "../../../../../core/model2/ai/@const"
import AIChatQueryMessage from "./item/query-message"
import AIChatAnswerMessage from "./item/answer-message"
import AIChatMessage_Collection from "../../../../../core/model2/ai/chat-message/collection"
import AiChatModule from "../../../../../core/gd-modules/ai-chat/ai-chat";

type Props = {
    message                 : AIChatMessage
    debugMessageCollection? : AIChatMessage_Collection
    module                  : AiChatModule
}

export default function AIChatMessage_Item(props: Props) {
    // i5-recurrence
    switch (props.message.type) {

        case AiChatMessageType.QUERY:
            return <AIChatQueryMessage message={props.message}/>

        case AiChatMessageType.ANSWER:
        case AiChatMessageType.ERROR:
            return (
                <AIChatAnswerMessage
                    module                  = {props.module}
                    debugMessageCollection  = {props.debugMessageCollection}
                    message                 = {props.message}
                />
            )

        case AiChatMessageType.TOOLS_CALL_REQUEST:
        case AiChatMessageType.TOOLS_CALL_RESPONSE:
        default:
            return null
    }
}
